import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import router from './router'
import store from './store'
import $util from '@/utils/utils'
import api from '@/api'
import columns from '@/utils/columns'
import urlt from '@/utils/urlt'
import chartOption from '@/echarts/chartOption'
import promptInformation from '@/components/PromptInformation'
import $message from '@/utils/message'
import Print from '@/utils/print/index.js'
import './scss/index.scss'
import './icons'
import VueGridLayout from 'vue-grid-layout';
// import 'echarts'

// import 'echarts/map/js/china'

import i18n from './lang/index'
import i18 from '@/utils/I18.js'
import Translate from '@/utils/translate.js'
import tools from "@/utils/tools";
import Marked from 'marked'
//引入自定义指令
import directives from '@/utils/directives.js'
import VueTypedJs from 'vue-typed-js'
Vue.use(VueTypedJs)
Vue.use(directives)
Vue.use(tools);

// 重写window.open
const originalWindowOpen = window.open;

// 重写 window.open 方法
window.open = function(url, name, specs, replace) {
    sessionStorage.setItem('openFrom', window.location.href)
    // 调用原始的 window.open 方法
    return originalWindowOpen.call(this, url, name, specs, replace);
};

// import * as VueGoogleMaps from 'vue2-google-maps'
// Vue.prototype.$echarts = echarts
Vue.prototype.$i18 = i18
Vue.use(ElementUI, {
    size: 'mini', // set element-ui default size
    i18n: (key, value) => i18n.t(key, value)
})


// import VueCompositionAPI from '@vue/composition-api'

// Vue.use(VueCompositionAPI)

// Vue.use(SlickSort)
// Vue.use(VueGoogleMaps, {
//   load: {
//       key: '你的 key',
//       libraries: '3.26',
//   },
// })
import ChartContent from '@/components/Chart/chartContent'
import MainTable from '@/components/MainTable'
Vue.component("ChartContent", ChartContent)
Vue.component("MainTable", MainTable)

Vue.component("promptbox", promptInformation)
Vue.component('VueGridLayout', VueGridLayout)
Vue.prototype.$api = api
Vue.prototype.$columns = columns
Vue.prototype.$url = urlt
Vue.prototype.$chartOption = chartOption
Vue.prototype.$message = $message
Vue.prototype.$util = $util
Vue.config.productionTip = false
Vue.prototype.Translate = Translate;  
Vue.prototype.Marked = Marked;  
Vue.component('GridLayout', VueGridLayout.GridLayout)
Vue.component('GridItem', VueGridLayout.GridItem)
Vue.use(Print);
    // const VUE_APP_VERSION = require('../package.json').version
    // const vers = window.localStorage.getItem("Version");
    // if(VUE_APP_VERSION != vers){
    //   console.log(VUE_APP_VERSION)
    //   window.localStorage.clear()
    //   window.sessionStorage.clear()
    //   window.localStorage.setItem("Version", VUE_APP_VERSION);
    // }
String.prototype.pxWidth = function(font) {
    // re-use canvas object for better performance
    var canvas = String.prototype.pxWidth.canvas || (String.prototype.pxWidth.canvas = document.createElement('canvas')),
        context = canvas.getContext('2d')
    font && (context.font = font)
    var metrics = context.measureText(this)
    return metrics.width
}

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')